import { createApp, provide } from 'vue';
import { createPinia } from 'pinia';
import _ from 'lodash'; 
import PublicRecordsRequestApp from './vue/public-records-request-app/app.vue'; 
//import { VueDatePicker } from '@vuepic/vue-datepicker';
//import '@vuepic/vue-datepicker/dist/main.css'

function InitPublicRecordsRequest(options) {
    const pinia = createPinia();
    const app = createApp(PublicRecordsRequestApp);
    app.use(pinia);
    _.forEach(options, (value, key) => app.provide(key, value));

    //app.component('VueDatePicker', VueDatePicker);

    app.mount('#PublicRecordsRequestApp');
}

export { InitPublicRecordsRequest }
